import { trace } from "firebase/performance";
import { getPerformance } from "firebase/performance";

// Initialize Firebase Performance
const perf = getPerformance();

/**
 * Wraps a Firestore operation with a custom trace for performance monitoring.
 * @param {string} traceName - The name of the trace (e.g., "fetch_tasks_trace").
 * @param {Function} operation - The Firestore operation to execute.
 * @returns {Promise|Function} - The result of the Firestore operation (e.g., unsubscribe function).
 */
export const withTrace = (traceName, operation) => {
  // Start a custom trace
  const t = trace(perf, traceName);
  t.start();

  try {
    // Execute the Firestore operation
    const result = operation();

    // If the result is a function (e.g., unsubscribe), return it directly
    if (typeof result === "function") {
      return () => {
        t.stop(); // Stop the trace when the unsubscribe function is called
        return result();
      };
    }

    // If the result is a promise, stop the trace when it resolves/rejects
    if (result && typeof result.then === "function") {
      return result
        .then((res) => {
          t.stop();
          return res;
        })
        .catch((err) => {
          t.stop();
          throw err;
        });
    }

    // For synchronous operations, stop the trace immediately
    t.stop();
    return result;
  } catch (error) {
    // Log the error and stop the trace
    console.error(`Error in trace "${traceName}":`, error);
    t.stop();
    throw error;
  }
};